<template>
    <v-card elevation="0" class="mb-3 pb-3">
          <v-card-title>{{$t(title) }}
     </v-card-title >
              <template v-for="(reminder) in reminders">
                     <v-card-subtitle class="pb-0 pt-0 font-weight-medium">
                          {{ reminder.contractName }}
                         <p class="mb-0"  v-if="reminder.reminderType === 'azpersons'">
                              {{$alvPlugin.showNameOfAzEntry(reminder.person) }}
                         </p>
                     </v-card-subtitle>
                     <v-card-text class="pb-0 mb-3">
                         <p class="mb-1" v-if="reminder.reminderType === 'azpersons'">
                                  {{ reminder.recontactHook && reminder.recontactHook.length > 50 ? reminder.recontactHook.slice(0, 50) + '...' : reminder.recontactHook }}
                         </p>
                         <p class="mb-1" v-else>
                              {{ $t('lang_CONTRACTS')}} > {{reminder.source === 'publishing' ? $t('lang_CONTRACTS_PUBLISHING_CONTRACTS'): $t('lang_CONTRACTS_LABEL_CONTRACTS') }}
                         </p>
                         <p class="mb-1">{{$t('lang_CONTRACTS_PUBLISHING_CAPTION_REMINDER_DATE')+': '+  $d(new Date(reminder.reminderDate), 'alvDateFormat') }}</p>
                         <p class="mb-1">
                             <router-link :to="navigateToReminder(reminder)">{{ reminder.alvId }}</router-link>
                         </p>
                     </v-card-text>
              </template>
      </v-card>   
 </template>
 
 <script>
 import BaseButton from '@/components/_buttons/BaseButton'
 export default {
     name: "BaseReminderCard",
     components: {
     BaseButton,
     BaseButton,
 },
     props: {
         reminders:Array,
         title:String,
     },
     methods: {
         navigateToReminder(reminder){
             if(reminder.source === 'publishing'){
                 return `/contracts/publishing/${reminder.alvId}`
             }else if(reminder.reminderType === 'azpersons'){
                 return `/az/azpersons/${reminder.alvId}`
             }else{
                 return `/contracts/label/${reminder.alvId}`
             }
         },
     }
 }
 </script>